export default "__VITE_ASSET__zebY$H17__"